import React from 'react';
import PropTypes from 'prop-types';
import ListComponent from '../List/CardList';
import withQuery from '../../lib/withQuery';

const DirectoryList = ({
  data, searchVariables, fetchMore, loading,
}) => {
  const { profilesConnection } = data;

  return (
    <ListComponent
      searchVariables={searchVariables}
      listItems={profilesConnection}
      fetchMore={fetchMore}
      data={data}
      field="profilesConnection"
      loading={loading}
      route="company-profile"
    />
  );
};

DirectoryList.propTypes = {
  data: PropTypes.shape({
    profilesConnection: PropTypes.shape({}),
  }),
  searchVariables: PropTypes.shape({}),
  fetchMore: PropTypes.func,
  loading: PropTypes.bool.isRequired,
};

DirectoryList.defaultProps = {
  searchVariables: {},
  data: {},
  fetchMore: undefined,
};

export default withQuery(DirectoryList);
